export const convertPointsToMoney = (points, rate) => {
  if (points == null || rate == null) return 0;
  return (points * rate).toFixed(2);
};
